import React from "react";
import ModalWalletItem from "./ModalWalletItem";
import detectEthereumProvider from "@metamask/detect-provider";

const checkProvider = async () => {
	const injectedProvider = await detectEthereumProvider();
	return injectedProvider;
};

const Modal = ({ setWalletChoice, isModalOpen, setIsModalOpen }) => {
	return (
		<div className="p-4 absolute inset-0 w-10/12 md:w-6/12 lg:w-5/12 xl:w-4/12 2xl:w-3/12 m-auto z-50 top-1/4 md:top-60 bottom-1/2 md:bottom-1/2 flex flex-col place-items-center rounded-lg drop-shadow-2xl bg-black gap-y-4">
			<div
				className="w-full flex justify-end pb-4 lg:pb-0"
				onClick={() => setIsModalOpen(!isModalOpen)}>
				<svg
					xmlns="http://www.w3.org/2000/svg"
					className="h-6 w-6 cursor-pointer"
					fill="none"
					viewBox="0 0 24 24"
					stroke="white"
					strokeWidth={2}>
					<path
						strokeLinecap="round"
						strokeLinejoin="round"
						d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
					/>
				</svg>
			</div>
			{(() => {
				if (checkProvider()) {
					return <ModalWalletItem
						id={"metamask"}
						name={"Metamask"}
						setWalletChoice={setWalletChoice}
						isModalOpen={isModalOpen}
						setIsModalOpen={setIsModalOpen}
					/>;
				}
			})()}
			<ModalWalletItem
				id={"walletconnect"}
				name={"WalletConnect"}
				setWalletChoice={setWalletChoice}
				isModalOpen={isModalOpen}
				setIsModalOpen={setIsModalOpen}
			/>
		</div>
	);
};

export default Modal;
